export default "__VITE_ASSET__DjMp16bQ__"